import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { withRouter, useRouteMatch,useHistory } from "react-router-dom";
import { exportLogo, safeUrl, scaleImage, siparisDurumText } from "../provider/functions";
import { changeLanguage } from "../redux";
import { useEffect, useRef, useState } from "react";
import { auth, firestore, getDocs } from "../provider/firebase";

import { collection, doc, getDoc, where,query, limit,onSnapshot, orderBy } from "firebase/firestore";
import moment from "moment";
import Sliders from "../components/Slider";
import { ScroolMotionDiv } from "../components/motion/AllMotions";
export default function WelcomePage() {
  const serverReducer = useSelector((state) => state.server.data);
  const {selected,data,countries,keys} = useSelector(state=>state.language);
  const dispatch = useDispatch();
  const garsonCagirVarmi = (serverReducer.garsonCagir || []).length>0
  const host = serverReducer.host;
  let match = useRouteMatch();
  const table = (match.params.table+"").toLowerCase();
  const [customLabels,setcustomLabels] = useState({})
  const [codes,setcodes] = useState([])
  const [lastOrder,setLastOrder] = useState({})
  const [langOpen, setLangOpen] = useState(false)
  const langRef = useRef(null)

  const flagEmoji = (code) => code.toUpperCase().split('').map(c => String.fromCodePoint(0x1F1E6 + c.charCodeAt(0) - 65)).join('')
  const history = useHistory()
  useEffect(()=>{
    var empty = {
      "AR":"Arabic"
    };
    var arrCodes = []
    countries.filter(v=>v.label && v.flag).sort((a,b)=>a.label>b.label?1:-1).map(value=>{
      empty[value.flag] = value.label;
      if(serverReducer.languages.includes(String(value.dilkodu).toUpperCase()) || serverReducer.languages.includes(value.flag) ){
        arrCodes.push(value.flag)
      }
    })
  
    setcodes(arrCodes)
    setcustomLabels(empty)

    const handleClickOutside = (e) => { if (langRef.current && !langRef.current.contains(e.target)) setLangOpen(false) }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)

    if(auth.currentUser){
       const q = query(collection(firestore,"/orders/"),where("uid","==",auth.currentUser.uid),where("server.id","==",serverReducer.id),orderBy("created","desc"),limit(1))
       getDocs(q).then(docs=>{
        if(!docs.empty){
          const last = docs.docs[0].data().packet;
           setLastOrder({...last,orders:last.orders.filter(v=>v.product?.id!="teslimat")});
        }
       })
    }
},[])

  const btnStyle = {
    width: '100%',
    padding: '16px 24px',
    borderRadius: 14,
    border: 'none',
    background:  '#000',
    color: '#fff',
    fontSize: 16,
    fontWeight: 600,
    cursor: 'pointer',
    letterSpacing: '-0.2px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    textDecoration: 'none',
    boxShadow: `0 6px 28px ${'#000'}40`,
    marginBottom: 12,
  };

  return (
    <div className="rp-app rp-first">
    <ScroolMotionDiv className="container-fluid" style={{backgroundImage:serverReducer.homeImage ?"url("+serverReducer.homeImage+")" :"",height:"100vh",backgroundPosition:'center',backgroundRepeat: "no-repeat",backgroundSize:'cover'}} onClick={(e)=>{
      if(serverReducer.homeImage) history.push((match.params.server?"/"+match.params.server:"")+"/"+match.params.table+"/menu")
    }}>
      <div className="rp-page-body rp-page-menu general" >
      <div className="rp-social-buttons">
        {safeUrl(serverReducer.facebook) && <a href={safeUrl(serverReducer.facebook)} target={"_blank"} className="link fb"><i className="fab fa-facebook-f"></i></a>}
        {safeUrl(serverReducer.twitter) && <a href={safeUrl(serverReducer.twitter)}  target={"_blank"} className="link tw"><i className="fab fa-twitter"></i></a>}
        {safeUrl(serverReducer.instagram) && <a href={safeUrl(serverReducer.instagram)}  target={"_blank"} className="link ig"><i className="fab fa-instagram"></i></a>}
        {safeUrl(serverReducer.whatsapp) && <a href={safeUrl(serverReducer.whatsapp)}  target={"_blank"} className="link " style={{backgroundColor:'green'}}><i className="fab fa-whatsapp"></i></a>}
        {safeUrl(serverReducer.website) && <a href={safeUrl(serverReducer.website)}  target={"_blank"} className="link "><i className="fab fa-internet-explorer"></i></a>}
        {serverReducer.telefon && <a href={"tel:"+serverReducer.telefon}  target={"_blank"} className="link "><i className="fas fa-phone"></i></a>}
        {safeUrl(serverReducer.harita) && <a href={safeUrl(serverReducer.harita)}  target={"_blank"} className="link "><i className="fas fa-map-marker-alt"></i></a>}
        
        </div>
        {!serverReducer.homeImage && <div className="rp-page-header rp-ph-general" style={{backgroundImage:"linear-gradient(205deg, "+serverReducer.bgcolor2+", "+serverReducer.bgcolor1+")",height:200}}/>}
        {!serverReducer.homeImage &&  <div className="rp-general-logo" >
          <img src={serverReducer.image ? scaleImage(serverReducer.image) :exportLogo(host)} alt="Logo" />
        </div>}
       
        {!serverReducer.homeImage && <div className="rp-info-general text-center">
        <div className="head">
            <h1 className="rp-general-title" style={{color:`${serverReducer.textColor}`}}>{serverReducer.qrTitle}</h1>
            <p className="rp-general-text"  style={{color:`${serverReducer.textColor}`}}>{serverReducer.qrDesc}</p>
          </div>
          <div className="rp-general-buttons" style={serverReducer.homeImage ? {position:'fixed',bottom:70,width:"90%"}:{}}>
            {/* <a  className="btn btn-primary btn-block">Kategoriler</a> */}
            <Link to={(match.params.server?"/"+match.params.server:"")+"/"+match.params.table+"/menu"} style={{...btnStyle,backgroundColor:'#e74c3c'}}>{data.menu}</Link>
            {safeUrl(serverReducer.googleYorum) ? <a href={safeUrl(serverReducer.googleYorum)} style={btnStyle}><i className="fa fa-comment"></i> <span>{data.bizi_degerlendir}</span></a> :<Link to={(match.params.server?"/"+match.params.server:"")+"/"+match.params.table+"/degerlendir"} style={btnStyle}><i className="fa fa-comment"></i> <span>{data.bizi_degerlendir}</span></Link>}
            {(lastOrder?.orders ) && 
            <Link to={(match.params.server?"/"+match.params.server:"")+"/"+match.params.table+"/profile"}   className="link-unstyled" >
              <div className="rp-product-box2 flex-start">
                {/* <div className="img"><img src="assets/img/kebab.png" alt="Image" /></div> */}
                <div className="content" style={{width:"100%"}}>
                  {lastOrder.docNo?<h2 className=" badge bg-dark" style={{color:'white',width:"100%"}}>{data.docno || "Order number"}: {lastOrder.docNo}</h2>:""}
                   <h2 className="title">{siparisDurumText(lastOrder.status)}</h2> 
                  <span className="text" style={{fontWeight:"bold",textAlign:"right"}}>{moment(lastOrder.created?.time).format("YYYY-MM-DD HH:mm")}</span>
                  <p className="text">{lastOrder.orders?.map(v=><div>{v.quantity+"x "+v.product?.title}</div>)}</p>
                  <div className="price" style={{color:'orange'}}>{lastOrder.total} {serverReducer.currency}  </div>
                  {lastOrder.paymentMethod ? <div className="badge bg-dark">{lastOrder.paymentMethod} </div> :""}
                  {lastOrder.status=="Error" ? <div className="badge bg-danger">{lastOrder.status} </div> :""}
                </div>
              </div>
            </Link>
         }
            {(table!="undefined" && table!="webstore" && garsonCagirVarmi) && <Link style={btnStyle} to={(match.params.server?"/"+match.params.server:"")+"/"+match.params.table+"/garsoncagir"}>{data.garson_cagir}</Link>}
            <Sliders />
            {codes.length > 1 && (
              <div ref={langRef} style={{position:'relative', marginTop: 12}}>
                {/* Trigger */}
                <button
                  onClick={(e) => { e.stopPropagation(); setLangOpen(v => !v); }}
                  style={{
                    width: '100%',
                    padding: '14px 18px',
                    borderRadius: 14,
                    border: '2px solid rgba(0,0,0,0.08)',
                    background: '#fff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    cursor: 'pointer',
                    boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                    fontFamily: 'inherit',
                    gap: 10,
                  }}
                >
                  <div style={{display:'flex', alignItems:'center', gap: 10}}>
                    <span style={{fontSize: 22, lineHeight: 1}}>{flagEmoji(selected)}</span>
                    <span style={{fontSize: 15, fontWeight: 600, color: '#111'}}>{customLabels[selected] || selected}</span>
                  </div>
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" style={{transform: langOpen ? 'rotate(180deg)' : 'none', transition:'transform 0.2s', flexShrink:0}}>
                    <path d="M2 4l4 4 4-4" stroke="#888" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>

                {/* Dropdown */}
                {langOpen && (
                  <div
                    onClick={e => e.stopPropagation()}
                    style={{
                      position: 'absolute',
                      bottom: '110%',
                      left: 0, right: 0,
                      background: '#fff',
                      borderRadius: 16,
                      boxShadow: '0 8px 40px rgba(0,0,0,0.14)',
                      border: '1px solid rgba(0,0,0,0.06)',
                      overflow: 'hidden',
                      zIndex: 999,
                      maxHeight: 260,
                      overflowY: 'auto',
                    }}
                  >
                    {codes.map(code => {
                      const isActive = code === selected;
                      return (
                        <button
                          key={code}
                          onClick={() => { dispatch(changeLanguage(code)); setLangOpen(false); }}
                          style={{
                            width: '100%',
                            padding: '13px 18px',
                            border: 'none',
                            background: isActive ? `${serverReducer.bgcolor1 || '#000'}14` : 'transparent',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 12,
                            cursor: 'pointer',
                            fontFamily: 'inherit',
                            borderBottom: '1px solid rgba(0,0,0,0.04)',
                          }}
                        >
                          <span style={{fontSize: 22, lineHeight: 1}}>{flagEmoji(code)}</span>
                          <span style={{fontSize: 14, fontWeight: isActive ? 700 : 500, color: isActive ? (serverReducer.bgcolor1 || '#000') : '#333'}}>
                            {customLabels[code] || code}
                          </span>
                          {isActive && (
                            <svg style={{marginLeft:'auto', flexShrink:0}} width="16" height="16" viewBox="0 0 16 16" fill="none">
                              <path d="M3 8l4 4 6-7" stroke={serverReducer.bgcolor1 || '#000'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          )}
                        </button>
                      );
                    })}
                  </div>
                )}
              </div>
            )}
            {/* <a  className="btn btn-resto btn-block">Kategoriler</a> */}
            
          </div>
        </div>}
       {/* {!serverReducer.hideLogo && <div className="rp-bottom">
          <span className="powered-text">Powered by <img src={exportLogo(host)} alt="Logo" /></span>
        </div>} */}
      </div>
    </ScroolMotionDiv>
  </div>
  
  );
}
